import { render, staticRenderFns } from "./OurEnvironment.vue?vue&type=template&id=d5f11962&scoped=true"
import script from "./OurEnvironment.vue?vue&type=script&lang=js"
export * from "./OurEnvironment.vue?vue&type=script&lang=js"
import style0 from "./OurEnvironment.vue?vue&type=style&index=0&id=d5f11962&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f11962",
  null
  
)

export default component.exports